module.exports = __webpack_public_path__ + "media/backgrounds/hugo-rouquette-u8oLHKcGLdQ-unsplash-a3fc5319.jpg";